import moment from 'moment';

export function firstOfMonthIn(i) {
    let date = new Date();
    date = new Date(date.getFullYear(), date.getMonth(), 1);
    date.setMonth(date.getMonth() + i);
    return date
}

export function monthName(date) {
    return date.toLocaleString('default', { month: 'long' });
}

export function getDefaultSalesAsOfDate(now = moment()) {
    return moment(now).subtract(1, 'days').format('YYYY-MM-DD');
}

export function getDefaultAccountingEndDate(now = moment()) {
    return moment(now).format('YYYY-MM-DD');
}
